module.exports = __webpack_public_path__ + "static/media/warehouse.ab70259f.svg";